// 和tailwind保持一致
export const xs = { maxWidth: 640 }
export const sm = { minWidth: 640 }
export const smallWindow = { maxWidth: 1600 }
export const md = { minWidth: 768 }
export const lg = { minWidth: 1024 }
export const xl = { minWidth: 1280 }
export const xxl = { minWidth: 1600 }
export const xxxl = { minWidth: 1824 }
